import 'css-chunksrc/client/pages/zonePage/reportsPage/report/indicatorsList/styles.scss';export default {
  "indicatorsList": "_indicatorsList_en1lt_1",
  "input": "_input_en1lt_10",
  "indicator": "_indicator_en1lt_1",
  "name": "_name_en1lt_27"
};